import React, { Component } from 'react';
import Header from '../common/layout/header';
import Footer from '../common/layout/footer';
import { Link } from "react-router-dom";


class Thankyou extends Component {

    constructor(props){
    super(props)
    
    if(!localStorage.getItem("isLoggedIn"))
    window.location.href = '/';  

    if(!localStorage.getItem("orderId"))
    window.location.href = '/';     
    }    


    render(){
        var currentdate = new Date(); 
        // var datetime =  currentdate.getDate() + "/"
        //                 + (currentdate.getMonth()+1)  + "/" 
        //                 + currentdate.getFullYear();

        var myDate = new Date();
        var year = myDate.getFullYear();
        var month = myDate.getMonth() + 1;
        if(month <= 9)
        month = '0'+month;
        var day= myDate.getDate();
        if(day <= 9)
        day = '0'+day;

        var prettyDate = day +'/'+ month +'/'+ year + ' ' +(myDate.getHours() < 10 ? '0' : '') + myDate.getHours() + ":"  
                + (myDate.getMinutes() < 10 ? '0' : '') + myDate.getMinutes();

        return(
        <>
        <Header/> 

            <section className="thank-section">

                <div className="sm-container">
                    <div className="thank-block">
                        <div className="thank-head">
                            <div className="thank-ico">
                                <i className="fa fa-check"></i>
                                <h3>Thank You</h3>
                                {localStorage.getItem('payment')=== 'A'?<p>Your order request has been successfully submitted</p> : <p>Your Payment has been Submitted Successfully</p>}
                            </div>
                        </div>
                        <div className="thank-body">
                            { <h1>Order No - {localStorage.getItem('orderId')}</h1> }
                            <p>Order Placed Date: <span>{prettyDate}</span></p>
                            <p>Order Delivery Date: <span>{localStorage.getItem('delivery_date')}</span></p>
                           {localStorage.getItem('payment')==='A'?<p>Payment Method: Pay Later</p>:<p>Payment Method: Online Payment</p>}
                            <Link to='/account' className="thank-btn button">Order Progress</Link>
                        </div>
                    </div>
                </div>

            </section>

        <Footer/>
        </>
        );
    }
}

export default Thankyou;